import React from 'react';
import logo from './homemalo.png';
import './App.css';
import Main from './Main';


const App = () => {
     return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Villa St Malo à 250m de la plage et du Sillon</h1>
          <h2 className="App-subtitle">Meilleur tarif - Réservez en direct et économisez les frais de service</h2>
        </header>
        <Main/>
      </div>
    );
  };



export default App;



// WEBPACK FOOTER //
// ./src/App.js